import { UserCoverStyle, Collection, PublicCollectionResponse } from "@authory-packages/core";

export const getCollectionDisplayImageUrl = (collection: Collection | PublicCollectionResponse) => {
    const isUnplashOrImage = collection.coverStyle === UserCoverStyle.image || collection.coverStyle === UserCoverStyle.unsplash;
    if (isUnplashOrImage && collection.coverImage.length) return collection.coverImage[0].url;

    if (collection.coverStyle === UserCoverStyle.color) {
        return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/preview/color?color=${collection.coverColor?.replace("#", "")}`;
    }
};

export const getCollectionOGDisplayImageUrl = (collection: Collection | PublicCollectionResponse) => {
    const isUnplashOrImage = collection.ogCoverStyle === UserCoverStyle.image || collection.ogCoverStyle === UserCoverStyle.unsplash;
    if (isUnplashOrImage && collection.ogCoverImage.length) return collection.ogCoverImage[0].url;

    if (collection.ogCoverStyle === UserCoverStyle.color) {
        return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/preview/color?color=${collection.ogCoverColor?.replace("#", "")}`;
    }

    const coverImage = getCollectionDisplayImageUrl(collection);
    if (coverImage) return coverImage;

    return "";
};
